import {
  DEFAULT_EMAIL_ERROR_MESSAGE,
  DEFAULT_REQUIRED_FIELD_MESSAGE,
} from "./constants";

export function isEmail(errorMessage) {
  return (val) => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      return true;
    }
    return errorMessage ? errorMessage : DEFAULT_EMAIL_ERROR_MESSAGE;
  };
}

export function isRequired(errorMessage) {
  return (val) => {
    if (val) {
      return true;
    }

    return errorMessage ? errorMessage : DEFAULT_REQUIRED_FIELD_MESSAGE;
  };
}
